import { render, staticRenderFns } from "./PermissionItem.vue?vue&type=template&id=192e325c"
import script from "./PermissionItem.vue?vue&type=script&lang=js"
export * from "./PermissionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports